import Logging from '~app/core/logging';

const log = Logging.getLogger('app.core.license');

export function formatLicense(licenseUrl) {
  let parsedLicenseText = licenseUrl.slice(0);

  const creativeCommonsUrl = "http://creativecommons.org/licenses/";
  const publicDomainUrl = "http://creativecommons.org/publicdomain/";

  // Parse a Creative Commons license.
  if (licenseUrl.startsWith(creativeCommonsUrl)) {
      // Remove the prefix.
      let licenseText = licenseUrl.slice(creativeCommonsUrl.length);

      // Remove the trailing slash if it exists.
      if (licenseText.endsWith("/")) {
          licenseText = licenseText.slice(0, -1);
      }

      if (licenseText === "publicdomain") {
          parsedLicenseText = "Public Domain";
      }
      else {
          const slashIndex = licenseText.indexOf("/");
          if (slashIndex !== -1) {
              let typeString = licenseText.slice(0, slashIndex);
              const versionString = licenseText.slice(slashIndex + 1);

              if (typeString === "publicdomain") {
                  // A public domain license with a number.
                  typeString = "Public Domain";
                  parsedLicenseText = `${typeString} ${versionString}`;
              }
              else {
                  // A by-nc-sa type license.
                  typeString = typeString.toUpperCase();
                  parsedLicenseText = `CC (${typeString} ${versionString})`;
              }
          }
      }
  }
  else if (licenseUrl.startsWith(publicDomainUrl)) {
      // damato: TODO: Do we need to distinguish between mark/1.0 and zero/1.0?
      parsedLicenseText = "Public Domain";
  }

  if (parsedLicenseText === licenseUrl) {
      log.warn(`Failed to parse license URL: ${licenseUrl}`);
  }

  return parsedLicenseText;
}



// WEBPACK FOOTER //
// ./src/core/license.js